// extracted by mini-css-extract-plugin
export default {"formContainer":"styles_formContainer__cCRtp","btnContainer":"styles_btnContainer__On05i"};